import React from "react";

export default React.memo(function QuizNavigation({
  onClickBack,
  onClickNext,
  onClickSave,
  currentStep,
  totalSteps,
}) {
  return (
    <React.Fragment>
      {currentStep !== 1 && (
        <button
          className="btn btn-outline-dark mt-10 mr-4 mb-12"
          onClick={onClickBack}
        >
          BACK
        </button>
      )}

      {currentStep !== totalSteps && (
        <button className="btn btn-dark mt-10 mr-4 mb-12" onClick={onClickNext}>
          NEXT
        </button>
      )}

      {currentStep === totalSteps && (
        <button className="btn btn-dark mt-10 mr-4 mb-12" onClick={onClickSave}>
          SAVE PROFILE
        </button>
      )}
    </React.Fragment>
  );
});
